// extracted by mini-css-extract-plugin
module.exports = {"root":"BookingTimeInfo_root__1HfMf","bookingInfo":"BookingTimeInfo_bookingInfo__1ag-P","dateSection":"BookingTimeInfo_dateSection__3XjbW"};